import { io, Socket } from 'socket.io-client';
import { ServerToClientEvents, ClientToServerEvents, InterServerEvents, SocketData } from '@shared/types';

const SOCKET_URL = import.meta.env.VITE_SOCKET_URL || '';

export const socket: Socket<ServerToClientEvents, ClientToServerEvents> = io(SOCKET_URL, {
  autoConnect: false,
  reconnection: true,
  reconnectionAttempts: 10,
  reconnectionDelay: 1000,
  reconnectionDelayMax: 5000,
  transports: ['websocket', 'polling'],
});

export default socket;
